module.exports = "/static/media/dan.54d9c9ac.jpg";